export class RelatorioAassembleia {

    static relatorioAassembleiaLista: RelatorioAassembleia[]  = [
        { tipo: 'pdf', descricao: '2014', caminho: 'relatorio_assembleia_2014.pdf' },
        { tipo: 'pdf', descricao: '2013', caminho: 'relatorio_assembleia_2013.pdf' },
        { tipo: 'pdf', descricao: '2012', caminho: 'relatorio_assembleia_2012.pdf' },
        { tipo: 'pdf', descricao: '2011', caminho: 'relatorio_assembleia_2011.pdf' },
        { tipo: 'pdf', descricao: '2010', caminho: 'relatorio_assembleia_2010.pdf' },
        { tipo: 'pdf', descricao: '2009', caminho: 'relatorio_assembleia_2009.pdf' },
        { tipo: 'pdf', descricao: '2008', caminho: 'relatorio_assembleia_2008.pdf' },
        { tipo: 'pdf', descricao: '2007', caminho: 'relatorio_assembleia_2007.pdf' },
        { tipo: 'pdf', descricao: '2006', caminho: 'relatorio_assembleia_2006.pdf' },
        { tipo: 'pdf', descricao: '4º Trimestre de 2006', caminho: 'resumo_assembleia_4tri2006.pdf' },
        { tipo: 'pdf', descricao: '3º Trimestre de 2006', caminho: 'relatorio_assembleia_3tri2006.pdf' },
        { tipo: 'pdf', descricao: '2º Trimestre de 2006', caminho: 'relatorio_assembleia_2tri2006.pdf' },
        { tipo: 'pdf', descricao: '1º Trimestre de 2006', caminho: 'relatorio_assembleia_4tri2006.pdf' },
        { tipo: 'pdf', descricao: '4º Trimestre de 2005', caminho: 'relatorio_assembleia_4tri2005.pdf' },
        { tipo: 'pdf', descricao: '3º Trimestre de 2005', caminho: 'relatorio_assembleia_3tri2005.pdf' },
        { tipo: 'pdf', descricao: '2º Trimestre de 2005', caminho: 'relatorio_assembleia_2tri2005.pdf' },
        { tipo: 'pdf', descricao: '1º Trimestre de 2005', caminho: 'relatorio_assembleia_1tri2005.pdf' },
        { tipo: 'pdf', descricao: '4º Trimestre de 2004', caminho: 'relatorio_assembleia_4tri2004.pdf' },
        { tipo: 'pdf', descricao: '3º Trimestre de 2004', caminho: 'relatorio_assembleia_3tri2004.pdf' },
        { tipo: 'pdf', descricao: '2º Trimestre de 2004', caminho: 'relatorio_assembleia_2tri2004.pdf' },
        { tipo: 'pdf', descricao: '1º Trimestre de 2004', caminho: 'relatorio_assembleia_1tri2004.pdf' },
        { tipo: 'pdf', descricao: '4º Trimestre de 2003', caminho: 'relatorio_assembleia_4tri2003.pdf' },
        { tipo: 'pdf', descricao: '3º Trimestre de 2003', caminho: 'relatorio_assembleia_3tri2003.pdf' },
        { tipo: 'pdf', descricao: '2º Trimestre de 2003', caminho: 'relatorio_assembleia_2tri2003.pdf' },
        { tipo: 'site', descricao: '1º Trimestre de 2003', caminho: 'relatorio_assembleia_1tri2003.htm' },
        { tipo: 'site', descricao: '4º Trimestre de 2002', caminho: 'relatorio_assembleia_4trimestre.htm' },
        { tipo: 'site', descricao: '3º Trimestre de 2002', caminho: 'relatorio_assembleia_3trimestre.htm' },
        { tipo: 'site', descricao: '2º Trimestre de 2002', caminho: 'relatorio_assembleia_1semestre.htm' },
        { tipo: 'site', descricao: '1º Trimestre de 2002', caminho: 'relatorio_assembleia.htm' }
    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {

    }



}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/relatorio-assembleia.ts